import styled from 'styled-components';

export const StyledCTA = styled.p`
  text-align: center;
  margin-bottom: ${props => props.theme.space.s5} !important;
`;
